'use client';
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

// BACKEND INTEGRATION: Replace with real FFCT hourly volume data from token API
const volumeData = [
  { hour: '00', volume: 142000, highlight: false },
  { hour: '02', volume: 98000, highlight: false },
  { hour: '04', volume: 76000, highlight: false },
  { hour: '06', volume: 183000, highlight: false },
  { hour: '08', volume: 312000, highlight: false },
  { hour: '10', volume: 287000, highlight: false },
  { hour: '11', volume: 341000, highlight: false },
  { hour: '12', volume: 298000, highlight: false },
  { hour: '13', volume: 419000, highlight: true },
  { hour: '14', volume: 387000, highlight: false },
  { hour: '15', volume: 356000, highlight: false },
  { hour: '16', volume: 445000, highlight: true },
];

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{ value: number }>;
  label?: string;
}

function CustomTooltip({ active, payload, label }: CustomTooltipProps) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-lg border border-zinc-700 bg-zinc-900 p-3 shadow-xl text-xs">
      <p className="text-zinc-400 mb-1 font-medium">{label}:00</p>
      <p className="font-mono text-white font-semibold">
        ${(payload[0]?.value ?? 0).toLocaleString()} FFCT vol
      </p>
    </div>
  );
}

export default function VolumeChart() {
  return (
    <div className="rounded-xl border border-zinc-800 bg-card p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-sm font-semibold text-white">24h Trading Volume</h3>
          <p className="text-xs text-zinc-500 mt-0.5">Hourly FFCT volume (USD)</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={volumeData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }} barSize={14}>
          <CartesianGrid stroke="hsl(0 0% 16%)" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="hour"
            tick={{ fill: 'hsl(0 0% 40%)', fontSize: 11, fontFamily: 'IBM Plex Mono' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${v}h`}
          />
          <YAxis
            tick={{ fill: 'hsl(0 0% 40%)', fontSize: 11, fontFamily: 'IBM Plex Mono' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`}
            width={48}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.03)' }} />
          <Bar dataKey="volume" radius={[3, 3, 0, 0]}>
            {volumeData.map((entry, index) => (
              <Cell
                key={`vol-bar-${index}`}
                fill={entry.highlight ? '#f7931a' : 'rgba(247,147,26,0.35)'}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}